import React from 'react';
import {Tag} from 'components';
import {shorten, getElementAttributes, useNamedSelector} from 'helpers';
import css from './tags-list.module.scss';

export function TagsList({ children, values, className, ...props }) {
  const { getByIds } = useNamedSelector('tags.tags');
  const tags = getByIds(values);
  return Boolean(tags.length > 0 || children) && (
    <div {...getElementAttributes(props)} className={css('tags', props, className)}>
      { children }
      { tags.map(tag =>
        <Tag {...props} key={tag.id} distinct={/google|icloud/i.test(tag.name)}>
          { shorten(tag.name) }
        </Tag>
      ) }
    </div>
  );
}
